import { Spin, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { SmallStyleDivider } from '../../../components/ActionStyles/ActionStyles'
import Button from '../../../components/Button'
import InfoIcon from '../../../components/icons/InfoIcon'
import { createMarkup, shuffleArray } from '../../../utils/helpers'
import { NumberToWord } from '../../../utils/numberToWord'
import {
  AlertText,
  AnsWrapper,
  Answer,
  BorderOnlyRadio,
  FooterFlex,
  NoteDiv,
  Question,
  QuestionFlex,
  QuestionNo,
  QuestionWrapper,
  QuestionnaireSectionWrapper,
  QuestionnaireWrapper,
  RedAsterisk,
  Sepreator,
  StyledAlert,
  StyledGroup,
  StyledNote,
  TopHeader,
  TopHeading,
  Wrapper,
} from '../Style/style'
import CrossIconSkill from 'components/icons/CrossIconSkill'

const Questionnaire = ({
  getSingleRoleQuestionSet,
  updateSingleRoleStudentAnswerSet,
  getSingleRoleStudentQuestionAnswerSet,
  ApplyRole,
  geStudentQuestionaireResult,
  RejectedRole,
  onClose,
  viewRoleDetails,
  setIsApproval,
  setExternalConfirm,
  setResumePopupVisible,
  setExternalResumeApply,
  setApprovalResumeApply
}) => {
  const params = useParams()
  const navigate = useNavigate()
  const [questionSetOne, setQuestionSetOne] = useState([])
  const [loading, setLoading] = useState(true)
  const [mertices, setMertices] = useState({
    mandatoryCount: 0,
    optionalCount: 0,
  })

  const [mandatoryAnswerset, setMandatoryAnswerset] = useState([])
  const [optionalAnswerset, setOptionalAnswerset] = useState([])

  const updateAnswerSet = async () => {
    let payload = {
      corporateId: params.CorpID,
      roleId: params.JobID,
      questions: [...mandatoryAnswerset, ...optionalAnswerset],
    }
    if (payload.questions?.length) {
      setLoading(true)
      const response = await updateSingleRoleStudentAnswerSet(payload)
      if (response?.status === 201) {
        setLoading(false)

        return true
      } else {
        setLoading(false)

        ErrorMessage(response.message)
        return false
      }
    } else {
      return true
    }
  }

  const fetchQuestions = async params => {
    try {
      const response = await getSingleRoleQuestionSet(
        params.CorpID,
        params.JobID
      )
      const StudentResponse = await getSingleRoleStudentQuestionAnswerSet(
        params.CorpID,
        params.JobID
      )
      if (response.status === 200) {
        let responseData = response?.data?.data || []
        let studentResponseData = StudentResponse?.data?.data || []
        if (!responseData.result?.length) {
          navigate(
            `/roles/questionnaire/${params.CorpID}/${params.JobID}job/result`
          )
        } else {
          const result = responseData.result?.map(item => {
            if (item.mixup) {
              item.questionBank.answer = shuffleArray(item.questionBank.answer)
            }
            return item
          })

          if (studentResponseData.result?.length) {
            const updatedSecondArray = responseData?.result?.map(
              corporateItem => {
                const matchingItem = studentResponseData.result?.find(
                  studentItem =>
                    studentItem.questionBankRoleMapId === corporateItem.id
                )

                if (corporateItem.mixup) {
                  corporateItem.questionBank.answer = shuffleArray(
                    corporateItem.questionBank.answer
                  )
                }
                if (matchingItem) {
                  corporateItem.questionBank.selectedAnswer =
                    matchingItem.selectedAnswer || []
                  if (corporateItem.mixup) {
                    matchingItem.answer = shuffleArray(matchingItem.answer)
                  }
                  let payloadObject = {
                    questionId: matchingItem?.questionBankRoleMapId,
                    question: matchingItem?.question,
                    answer: matchingItem?.answer,
                    selectedAnswer: matchingItem?.selectedAnswer,
                    mandatory: matchingItem?.mandatory,
                  }
                  if (corporateItem.mandatory) {
                    setMandatoryAnswerset(prevAnswerSet => {
                      return [...prevAnswerSet, { ...payloadObject }]
                    })
                  } else {
                    setOptionalAnswerset(prevAnswerSet => {
                      return [...prevAnswerSet, { ...payloadObject }]
                    })
                  }
                }
                return corporateItem
              }
            )

            setQuestionSetOne(updatedSecondArray)
          } else {
            setQuestionSetOne(result || [])
          }
        }
        setLoading(false)
        setMertices({
          mandatoryCount: responseData?.mandatoryCount,
          optionalCount: responseData?.optionalCount,
        })
      } else {
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchQuestions(params)
  }, [])

  const handleAnswerSetChange = (value, questionId, mandatory, questions) => {
    let payloadObject = {
      questionId: questionId,
      question: questions?.questionBank?.question,
      answer: questions?.questionBank?.answer,
      mandatory: mandatory,
    }
    let modifiedValue
    if (typeof value == 'string') {
      modifiedValue = [value]
    } else {
      modifiedValue = value
    }
    if (mandatory) {
      setMandatoryAnswerset(prevAnswerSet => {
        const index = prevAnswerSet.findIndex(
          item => item.questionId === questionId
        )

        if (index !== -1) {
          if (modifiedValue?.length) {
            prevAnswerSet[index].selectedAnswer = modifiedValue
            prevAnswerSet[index].mandatory = mandatory

            return [...prevAnswerSet]
          } else {
            return prevAnswerSet?.filter((value, idx) => idx !== index)
          }
        } else {
          return [
            ...prevAnswerSet,
            { ...payloadObject, selectedAnswer: modifiedValue },
          ]
        }
      })
    } else {
      setOptionalAnswerset(prevAnswerSet => {
        const index = prevAnswerSet?.findIndex(
          item => item.questionId === questionId
        )

        if (index !== -1) {
          prevAnswerSet[index].selectedAnswer = modifiedValue
          prevAnswerSet[index].mandatory = mandatory
          return [...prevAnswerSet]
        } else {
          return [
            ...prevAnswerSet,
            { ...payloadObject, selectedAnswer: modifiedValue },
          ]
        }
      })
    }

    setQuestionSetOne(prevQuestionSet => {
      const index = prevQuestionSet?.findIndex(item => item.id === questionId)
      if (index !== -1) {
        prevQuestionSet[index].questionBank.selectedAnswer = value
        return [...prevQuestionSet]
      }
    })
  }

  const studentQuestionnariResult = async () => {
    const response = await geStudentQuestionaireResult(
      params.CorpID,
      params.JobID
    )

    let data = {
      id: params.JobID,
      corporateId: params.CorpID,
    }
    if (response.status === 200) {
      if (response?.data?.data?.count == response?.data?.data?.mandatoryCount) {
        const roleAppliedResult = await ApplyRole(data, {
          questionnaire: true,
        })
        if (onClose) {
          onClose();
        }
        // if (roleAppliedResult?.status == 201) {
        //   navigate(
        //     `/roles/questionnaire/${params.CorpID}/${params.JobID}/job/result`
        //   )
        // } else {
        //   setLoading(false)
        //   navigate(`/roles/questionnaire/job/re-applied`)
        // }
      } else {
        const roleRejectedResult = await ApplyRole(data, {
          questionnaire: true,
        })
        if (onClose) {
          onClose();
        }
      }
      setLoading(true)
      // navigate(
      //   `/roles/questionnaire/${params.CorpID}/${params.JobID}/job/result`
      // )
    } else {
      ErrorMessage(response.message)
    }
  }
  const handleFinish = async () => {
    try {
      const updated = await updateAnswerSet()
      if (updated) {
        SuccessMessage('Updated Successfully !')
        if(viewRoleDetails?.isRestricted){
          onClose()
         // setIsApproval(true)
         setResumePopupVisible(true)
         setApprovalResumeApply(true)
        }
        if (!viewRoleDetails?.isRestricted && viewRoleDetails?.role?.externalLink) {
          onClose()
          setExternalConfirm(true)
        }
        else if(!viewRoleDetails?.isRestricted && !viewRoleDetails?.role?.externalLink){
        //  await studentQuestionnariResult()
        onClose()
        setExternalResumeApply(true)
        setResumePopupVisible(true)
        }
        
        // Close the modal after showing success message
       
      }
    } catch (err) {
      console.log(err)
    }
  }

  //to block back button

  history.pushState(null, null, location.href)
  window.onpopstate = function () {
    history.go(1)
  }

  return (
    <QuestionnaireSectionWrapper column>
      <TopHeader padding={'22px 0px 16px 40px'} row spaceBetween alignCenter>
        <TopHeading flexStart>
          Questionnaire <Sepreator />
          <NoteDiv>
            <StyledAlert
              message={
                <AlertText>
                  Note : Please ensure all mandatory questions are answered
                </AlertText>
              }
              type="info"
              showIcon
              icon={<InfoIcon />}
            />
          </NoteDiv>
        </TopHeading>
             <div onClick={onClose} style={{ cursor: 'pointer',paddingRight:'40px' }}>
                   <CrossIconSkill />
                 </div>
      </TopHeader>
      <SmallStyleDivider />
      <QuestionnaireWrapper>
        {loading && <Spin />}
        {!loading &&
          questionSetOne.map((questions, index) => {
            if (questions?.questionBank?.questionType == 'BINARY') {
              let marginTop = index == 0 ? index : '47px'

              const answers = questions?.questionBank?.answer || []

              const indexOfYes = answers.indexOf('Yes')
              const indexOfTrue = answers.indexOf('True')

              // If 'Yes' is found, reorder the array
              if (indexOfYes !== -1) {
                answers.splice(indexOfYes, 1)
                answers.unshift('Yes')
              }

              // If 'True' is found, reorder the array
              if (indexOfTrue !== -1) {
                answers.splice(indexOfTrue, 1)
                answers.unshift('True')
              }
              const selectedAnswer =
                typeof questions?.questionBank?.selectedAnswer === 'string'
                  ? questions?.questionBank?.selectedAnswer
                  : questions?.questionBank?.selectedAnswer?.[0]

              const question = questions?.questionBank?.question?.replace(
                /&nbsp;/g,
                ''
              )

              return (
                <QuestionFlex marginTop={marginTop} key={index+"question"}>
                  <QuestionNo>Q{index + 1}.</QuestionNo>
                  <Wrapper>
                    <QuestionWrapper>
                      <Question>
                        {
                          <div
                            dangerouslySetInnerHTML={createMarkup(question)}
                          />
                        }
                      </Question>
                      {questions?.mandatory && (
                        <RedAsterisk color="red">*</RedAsterisk>
                      )}
                    </QuestionWrapper>
                    <AnsWrapper
                      column
                      start
                      width="90%"
                      onChange={e =>
                        handleAnswerSetChange(
                          e.target.value,
                          questions?.id,
                          questions?.mandatory,
                          questions
                        )
                      }
                      value={selectedAnswer}
                    >
                      {answers?.map((answer, index) => (
                        <BorderOnlyRadio
                          marginTop={index > 0 ? '18px' : 0}
                          value={answer}
                          key={index+"answer"}
                        >
                          <Answer width={'100%'}>{answer}</Answer>
                        </BorderOnlyRadio>
                      ))}
                    </AnsWrapper>
                  </Wrapper>
                </QuestionFlex>
              )
            } else if (questions?.questionBank?.questionType == 'MULTIPLE') {
              let marginTop = index == 0 ? index : '47px'

              const selectedAnswer =
                typeof questions?.questionBank?.selectedAnswer === 'string'
                  ? questions?.questionBank?.selectedAnswer
                  : questions?.questionBank?.selectedAnswer?.[0]

              const question = questions?.questionBank?.question?.replace(
                /&nbsp;/g,
                ''
              )

              return (
                <QuestionFlex marginTop={marginTop} key={index+"question"}>
                  <QuestionNo>Q{index + 1}.</QuestionNo>
                  <Wrapper>
                    <QuestionWrapper>
                      <Question>
                        {
                          <div
                            dangerouslySetInnerHTML={createMarkup(question)}
                          />
                        }
                      </Question>
                      {questions?.mandatory && (
                        <RedAsterisk color="red">*</RedAsterisk>
                      )}
                    </QuestionWrapper>
                    {questions?.correctAnswerCount > 1 && (
                      <StyledNote>
                        NOTE : Please select any
                        {NumberToWord(questions?.correctAnswerCount)}
                        answers.
                      </StyledNote>
                    )}
                    {questions?.correctAnswerCount <= 1 ? (
                      <AnsWrapper
                        column
                        start
                        width="90%"
                        onChange={e =>
                          handleAnswerSetChange(
                            e.target.value,
                            questions.id,
                            questions.mandatory,
                            questions
                          )
                        }
                        value={selectedAnswer}
                      >
                        {questions?.questionBank?.answer?.map(
                          (answer, index) => (
                            <BorderOnlyRadio
                              marginTop={index > 0 ? '18px' : 0}
                              value={answer}
                              key={index+"answer"}
                            >
                              <Answer width={'100%'}>{answer}</Answer>
                            </BorderOnlyRadio>
                          )
                        )}
                      </AnsWrapper>
                    ) : (
                      <StyledGroup
                        marginTop={index > 0 ? '5px' : 0}
                        options={questions?.questionBank?.answer?.map(
                          option => ({
                            label: option,
                            value: option,
                            disabled:
                              questions?.correctAnswerCount ===
                                questions?.questionBank?.selectedAnswer
                                  ?.length &&
                              !questions?.questionBank?.selectedAnswer?.includes(
                                option
                              ),
                          })
                        )}
                        onChange={checkedValue => {
                          handleAnswerSetChange(
                            checkedValue,
                            questions?.id,
                            questions?.mandatory,
                            questions
                          )
                        }}
                        value={questions?.questionBank?.selectedAnswer}
                      />
                    )}
                  </Wrapper>
                </QuestionFlex>
              )
            }
          })}
      </QuestionnaireWrapper>
      <SmallStyleDivider />
      {!loading && (
        <FooterFlex right padding={'12px 14px'} gap={'20px'}>
           <Button.Secondary text="Back" onClick={onClose} />
          <Tooltip
            title={
              mandatoryAnswerset?.length !== mertices?.mandatoryCount
                ? 'Please ensure all mandatory questions are answered'
                : ''
            }
          >
            <div style={{ display: 'inline-block' }}>
              <Button.IconButton
                width={'100px'}
                text-align={'center'}
                text={'Finish'}
                onClick={() => handleFinish()}
                disabled={
                  mandatoryAnswerset?.length !== mertices?.mandatoryCount
                }
              />
            </div>
          </Tooltip>
        </FooterFlex>
      )}
    </QuestionnaireSectionWrapper>
  )
}

export default Questionnaire
